import React from "react";

export default function MemoryCard({ card, onClick }) {

  return ( // Each card has a front (the back of the card) and a back (the image). The "flipped" class controls the flip animation and visibility of the front/back sides.
    <div
      className={`card ${card.flipped || card.matched ? "flipped" : ""}`}
      onClick={onClick}
    >

      <div className="card-inner">

        <div className="card-front"></div>

        <div className="card-back">
          <img src={card.image} alt="" />
        </div>

      </div>

    </div>
  );
}